import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../state/store";
import { getListAction } from "../../../../state/usecase/admin/admin_operation_log/actions";
import { AdminOperationLogTable } from "./components/AdminOperationLogTable";

export const AdminOperationLogPage = React.memo(function AdminOperationLogPage() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getListAction());
    }, []);

    return (
        <div className={"admin_operation_log_page"}>
            {/* ページタイトル */}
            <div className={"header"}>
                管理者操作ログ
            </div>

            {/* ページコンテンツ */}
            <div className={"container"}>
                <AdminOperationLogTable />
            </div>
        </div>
    );
});
